import base from '@/http/url_base';

export default {
  GET_REQUIREMENTS: base.API + '/article-stocks/requirements',

  STOCK_GLOBAL: base.API + '/article-global-stocks',
  STOCK_ENTREPOT: base.API + '/article-entrepot-stocks',
  STOCK_LOT: base.API + '/article-lot-stocks',
  STOCK_ENTREPOT_LOT: base.API + '/article-entrepot-lot-stocks',
};
